import { CustomerIdentityDocumentType } from 'src/app/models/enums/customer-identity-document-type';

/**
 * T.C. Kimlik Numarası denetimi — 11 hane, ilk hane 0 değil, 10. ve 11. hane algoritması.
 * Backend JewApi.Validators.TcknValidator ile aynı kural (masak-kimlik-ocr.md).
 */
export function isValidTckn(value?: string | null): boolean {
  if (!value || !/^[1-9][0-9]{10}$/.test(value)) return false;
  const d = value.split('').map(Number);
  const odd = d[0] + d[2] + d[4] + d[6] + d[8];
  const even = d[1] + d[3] + d[5] + d[7];
  const tenth = (((odd * 7 - even) % 10) + 10) % 10;
  if (tenth !== d[9]) return false;
  const sum = d.slice(0, 10).reduce((a, b) => a + b, 0);
  return sum % 10 === d[10];
}

/** Yeni tip T.C. Kimlik Kartı seri no biçimi (A12B34567) — tutmazsa yalnızca uyarı. */
export function isTcknCardSerial(value?: string | null): boolean {
  return !!value && /^[A-Z][0-9]{2}[A-Z][0-9]{5}$/.test(value.trim().toUpperCase());
}

/** yyyy-MM-dd ya da Date — gün bugünden önceyse true (bugün geçerli sayılır). */
export function isDocumentExpired(expiryDate?: Date | string | null, today: Date = new Date()): boolean {
  if (!expiryDate) return false;
  const expiry = String(expiryDate).substring(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(expiry)) return false;
  const pad = (n: number) => String(n).padStart(2, '0');
  const todayText = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
  return expiry < todayText;
}

/**
 * Listede/detayda belge numarası metni. T.C. Kimlik Kartı'nda belge no seri no'dur:
 * "Seri No: A12B34567". SUB_057 öncesi kayıtlarda belge no TCKN'nin kendisiydi; script onu
 * tckn'e kopyaladıysa (ikisi eşit) seri no bilinmiyor — boş döner, TCKN ayrı gösterilir.
 * Backend MasakFormHtml.DocumentText ile aynı kural.
 */
export function identityDocumentNumberText(record: {
  documentType?: CustomerIdentityDocumentType;
  documentNumber?: string;
  tckn?: string;
}): string {
  const number = record.documentNumber?.trim() ?? '';
  if (record.documentType !== CustomerIdentityDocumentType.Tckn || !record.tckn) return number;
  return !number || number === record.tckn ? '' : `Seri No: ${number}`;
}
